import { render } from "./ReportEditor.vue?vue&type=template&id=c1aeb45c&scoped=true"
import script from "./ReportEditor.vue?vue&type=script&lang=js"
export * from "./ReportEditor.vue?vue&type=script&lang=js"

import "./ReportEditor.vue?vue&type=style&index=0&id=c1aeb45c&lang=scss&scoped=true"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1aeb45c"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
